import { loadOrgModel } from "../../api/connection";
import { createModel, Model } from "../../models/Model";
import { BaseService } from "./BaseService";

export class ModelService extends BaseService {
  private models = new Map<string, Model>();
  render(delta: number): void {}
  public setModels(models: Model[]): void {
    this.models.clear();
    models.forEach(model => {
      this.models.set(model._id, model);
    });
  }
  public async getModel(modelId: string): Promise<any> {
    if (this.models.has(modelId)) {
      return this.models.get(modelId);
    }
    const created = createModel(modelId);
    await loadOrgModel(created);
    this.models.set(modelId, created);
    return created;
  }
}